module.exports = __webpack_public_path__ + "img/hemline_sweep.9baddca5.png";